<template>
    <div class="orderListWrap11">
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    <el-form-item style="width: 260px;">
                        <el-input  style="width: 260px;" placeholder="订单号/用户姓名/品牌/公司/款号" v-model="fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="选择公司" v-model="currentSelectCompany" @change="changeCompany" >
                            <el-option label="所有公司" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in companyWord" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="请选择品牌" v-model="currentSelectBrand" @change="changeBrand">
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in brandWprd" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="downLoadExcel(2)">下载表格</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
       <!-- <div style="padding:10px 20px;text-align: right;;">
          <el-button type="primary">下载表格</el-button>
          <el-button type="primary">打印</el-button>
        </div> -->
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <el-table-column type="selection" width="35">
                </el-table-column>
                <el-table-column label="序号" width="40">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="订单号">
                    <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
                </el-table-column>
                <el-table-column label="用户姓名" width="50">
                    <template slot-scope="scope">{{ scope.row.realName }}</template>
                </el-table-column>
                <el-table-column label="总数" width="50">
                    <template slot-scope="scope">{{ scope.row.quantity }} 件</template>
                </el-table-column>
                <el-table-column label="总金额">
                    <template slot-scope="scope">{{ scope.row.amount }} 元</template>
                </el-table-column>
                <el-table-column label="下单时间">
                    <template slot-scope="scope">{{ scope.row.submitTime }}</template>
                </el-table-column>
                <el-table-column label="状态" width="50">
                    <template slot-scope="scope">
                        <span :class="{red:scope.row.orderState=='1',green:scope.row.orderState=='2',orange_lighter:scope.row.orderState=='3'}">{{ scope.row.orderState |turnValToText('order_pay_status')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="公司">
                    <template slot-scope="scope">{{ scope.row.ces }}</template>
                </el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <div class="oneItem picture" v-for="(list,index) in scope.row.list" :key="list.imageFile">
                            <img :src="IMG_PREV+list.imageFile" alt="">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="品牌" width="50">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.ces}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="款号">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.styleNumber}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="商品名称">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.itemName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="颜色" width="50">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.colorName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="数量" width="50">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.totalNum}} 件</div>
                    </template>
                </el-table-column>
                
                <el-table-column label="操作"  width="130">
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <span class="spanBtn" @click="toDetail(scope.row)">查看</span>
                            <span class="spanBtn orange" @click="checkReceiveMoney(scope.row)" v-if="scope.row.orderState==1">确认收款</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
                :page-size.sync="num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                isLoading:false,
                tableData:[],
                //查询条件
                fuzzyQuery:'',
                page: 1,
                num: 10,
                currentSelectCompany:'',
                currentSelectBrand:'',
                searchObj:{},//最终组装好的搜索条件

                total:0,
                conferenceId:'',
                companyWord:[],
                brandWprd:[],
            }
        },
        components: {
        },
        computed: {
            IMG_PREV() {
                return api.imgPrev
            },
            adminId(){
                return utils.getAdminId()
            }
            
        },
        methods: {
            changeBrand(){
                //查询表格
                let _this=this
                _this.page = 1
                _this.getTableLists()
            },
            changeCompany(){
                let _this=this
                _this.currentSelectBrand=''
                _this.brandWprd=[]
                let arg={
                    conferenceId:_this.conferenceId,
                    userId:_this.currentSelectCompany,
                }
                //获取公司下的品牌
                ajaxPost('/admin/brandlist', arg).then(function(res) {
                    if(res.errorCode==200){
                        let resData=res.data?res.data:[]
                        _this.brandWprd=resData.map(function(item,index){
                            let buffer={
                                text:item.brandName,
                                value:item.brandId,
                            }
                            return buffer
                        })
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
                //查询表格
                _this.page = 1
                _this.getTableLists()
                
            },
            getCompanyOption(){
                let _this=this
                let arg={
                    conferenceId:_this.conferenceId,
                }
                ajaxPost('/admin/companylist', arg).then(function(res) {
                    if(res.errorCode==200){
                        let resData=res.data?res.data:[]
                        _this.companyWord=resData.map(function(item,index){
                            let buffer={
                                text:item.companyName,
                                value:item.userId,
                            }
                            return buffer
                        })
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            refreshPage(){
              this.getTableLists()  
            },
            checkReceiveMoney(list) {
                let _this = this
                if (!confirm("确认该订单已收款吗？")) {
                    return false
                }
                let arg = {
                    orderNumber: list.orderNumber
                }
                ajaxPost('/admin/confirmPay', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "确认收款成功",
                            type: 'success',
                            duration: 1500
                        });
                        _this.refreshPage()
                    }
                }, function(res) {
            
                })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
            },
            downLoadExcel(type){
                let _this=this
                let arg={
                    adminId:_this.adminId,
                    conferenceId:_this.conferenceId,
                    type:type
                }
                ajaxPost('/file/exportHttp', arg).then(function(res) {
                   if(res.errorCode==200){
                       _this.$message("下载成功")  
                   
                       let url=res.data
                       window.location.href= _this.IMG_PREV+url
                       
                   }else{
                       _this.$message(res.errorMsg)
                   }
                }, function(res) {
                
                })
            },
            fuzzySearchClick() {
                this.page=1
                this.currentSelectCompany=""
                this.currentSelectBrand=''
                this.getTableLists()
            },
            handleSizeChange(size) { //分页：每页n条
                this.num = size
                this.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.page = page
                this.getTableLists()
            },
            getTableLists(){
                let _this=this
                _this.isLoading=true
                _this.searchObj={
                    num:_this.num,
                    page:_this.page,
                    fuzzyQuery:_this.fuzzyQuery,
                    userId:_this.currentSelectCompany,
                    brandId:_this.currentSelectBrand,
                }
                    
                let arg=JSON.parse(JSON.stringify(_this.searchObj))
                arg.conferenceId=_this.conferenceId
                ajaxPost('/admin/getconferenceOrder', arg).then(function(res) {
                    _this.tableData=res.data.list
                    _this.total=parseInt(res.data.num) 
                    _this.customerTotal=res.data.num
                    _this.isLoading=false
                }, function(res) {
                    _this.isLoading=false
                })
            },
            toDetail(list) {
                let _this=this 
                let orderNumber=list.orderNumber
                this.$router.push({name: 'activeInnerOrderDetail',params: { conferenceId: _this.conferenceId ,orderNumber:orderNumber}})
            },
        },
        mounted(){
           this.getParams()
           this.getTableLists()
           this.getCompanyOption()

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    // *{outline: 1px solid blue;}
    .orderListWrap11 {
       background: #fff;
       .oneItem{border-bottom:1px solid #efefef;height: 50px;padding:3px;}
       .oneItem:last-child{border-bottom:0}
       .right .el-form--inline .el-form-item{margin-right: 0px; max-width: 150px;}
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
             float:right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       
       .tableBox {
           padding: 0.25rem; padding-top:0;
           // .oneItem{border-bottom:1px solid blue;}
           .oneItem.picture{ 
               height: 50px;
               img{max-width: 100%;max-height: 100%;}
           }
           
       }
       .el-table .cell{font-size: 12px;padding:4px 0;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/order.vue